import borders from './borders';
import { getColors } from './colors';
import generalVariables from './generalVariables';
import spacing from './spacing';
import typography from './typography';
// TODO(giles): fix this
// eslint-disable-next-line import/no-named-as-default

export type ThemeName = 'default' | 'dark';
export type ComponentTheme = ReturnType<typeof getTheme>;

export interface ThemeOptions {
  enableAnimation: boolean;
  zIndexBase: number;
}

export interface Theme {
  colors: ReturnType<typeof getColors>;
  spacing: typeof spacing;
  general: typeof generalVariables;
  typography: typeof typography;
  borders: typeof borders;
  themeName: ThemeName;
  options: ThemeOptions;
}

const defaultOptions: ThemeOptions = {
  enableAnimation: false,
  zIndexBase: 1000,
};

// Function to get variables for a certain theme.
// End users should use useDesignSystemTheme instead.
export function getTheme(themeName: ThemeName, options: ThemeOptions = defaultOptions): Theme {
  return {
    colors: getColors(themeName),
    spacing,
    general: generalVariables,
    typography,
    borders,
    themeName,
    options,
  };
}
